export default "__VITE_ASSET__DIBYwQuf__"